<form [cwoAriaForm]="loginForm" [formGroup]="loginForm" class="login-container" (ngSubmit)="onSubmit()" *transloco="let t;">
    @if(allErrors?.length){
        <div class="generic-errors">
            @for (error of allErrors; track $index) {
                <span class="error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{error}}.</span>
            }
        </div>
    }
    <div class="form-container">
        <div class="input-wrapper">
            <cwo-input formControlName="email" [type]="'email'" [useRequiredLabel]="false" [placeholder]="t('shared_components.signing_forms.login_form.email_placeholder')" [required]="true" [invalid]="showErrors && email.invalid"/>
            <div class="errors-wrapper">
                @if(showErrors && email.invalid){
                    @if(email.hasError('required')){
                        <span class="input-error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{validationMessages.email.required}}.</span>
                    }
                    @if(email.hasError('email')){
                        <span class="input-error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{validationMessages.email.email}}.</span>
                    }
                }
            </div>
        </div>
        <div class="input-wrapper">
            <cwo-input formControlName="password" [type]="'password'" [useRequiredLabel]="false" [placeholder]="t('shared_components.signing_forms.login_form.password_placeholder')" [required]="true" [invalid]="showErrors && password.invalid"/>
            <div class="errors-wrapper">
                @if(showErrors && password.invalid){
                    @if(password.hasError('required')){
                        <span class="input-error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{validationMessages.password.required}}.</span>
                    }
                    @if(password.hasError('minlength') || password.hasError('maxlength') ){
                        <span class="input-error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{validationMessages.password.minlength}}</span>
                    }
                }
            </div>
        </div>
    </div>
    <button id="forgot-password-btn" class="button-undecorated forgot-password" type="button" (click)="onForgotClicked()">
        {{t('shared_components.signing_forms.login_form.forgot_password')}}
    </button>
    @if(accountResourceConfig && accountResourceConfig.usesRecaptchaValidation && accountResourceConfig.recaptchaSiteKey){
        <div class="recaptcha-wrapper">
            <label class="checkbox-label recaptcha-label" for="g-recaptcha-response">{{t('shared_components.signing_forms.login_form.required')}}</label>
            <re-captcha siteKey="{{accountResourceConfig.recaptchaSiteKey}}" (resolved)="recaptchaResolved($event)"></re-captcha>
            <div class="errors-wrapper">
                @if(showErrors && !recaptcha.value){
                    <span class="input-error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{validationMessages.recaptcha.required}}.</span>
                }
            </div>
        </div>
    }
        
    <div class="buttons-container" [class.with-external-sign-in]="hasExternalSignIn()">
        <button cwoAsyncButton [subscription]="loadingSubscription" type="submit" 
        [ngClass]="{
            'sign-in': true,
            'button-accent-secondary': !hideGuestButton(),
            'button-accent': hideGuestButton()
        }">
            {{t('shared_components.signing_forms.login_form.sign_in')}}
        </button>

        @if(hasExternalSignIn()){
            <cwo-external-sign-in/>
        }

        @if(!hideGuestButton()){
            <div class="or-container">
                <span class="or">{{t('shared_components.signing_forms.login_form.or')}}</span>
            </div>
            <button type="button" class="guest" (click)="handleContinueAsGuest()">{{t('shared_components.signing_forms.login_form.continue_as_guest')}}</button>
        }
        
    </div>
    @if(showTableNumberText()){
        <div class="table-number-display">{{t('shared_components.signing_forms.login_form.table_number_display_label')}} {{tableNumber()}}</div>
    } @else if(showTableNumberInput()){
        <div class="table-number-wrapper">
            <cwo-input
                [ngModel]="tableNumber()"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="tableNumberChange.emit($event)"
                (focusout)="tableNumberBlur.emit()"
                [type]="'text'"
                [placeholder]="t('shared_components.signing_forms.login_form.table_number_placeholder')"
                [required]="true"
                [invalid]="showTableNumberError()"
            />
            @if(showTableNumberError()){
                <span class="input-error">{{validationMessages.tableNumber.required}}</span>
            }
        </div>
    }
</form>
